import * as actionTypes from './actionTypes';
import axios from '../../_services/api/axios'
import { authChangeCurrentUser, authRemoveMelcoAccountData, authSetMelcoAccountData } from './auth';
import { useSupportToken } from '../../hooks/useSupportToken';


/* ----------------- Token Restore ------------------ */
export const tokenRestoreSuccess = () => {
    return {
        type: actionTypes.TOKEN_RESTORE_SUCCESS
    };
};

export const tokenRestoreFail = () => {
    return {
        type: actionTypes.TOKEN_RESTORE_FAIL,
    };
};

export const tokenRestoreStart = () => {
    return {
        type: actionTypes.TOKEN_RESTORE_START
    };
};

export const tokenRestoreToken = (token, user_id) => {
    return async (dispatch) => {
        dispatch(tokenRestoreStart());
        
        const loginViaSupportToken = useSupportToken();

        const searchParams = new URLSearchParams(window.location.search);
        const supportToken = searchParams.get("token");

        if (supportToken) {
            const { isValidToken, user } = await loginViaSupportToken(
                supportToken
            ); 

            if (isValidToken && user) {
                const { token, user_id, first_name, last_name, account_name, parent_user_id, impersonation_for_id } = user;

                dispatch(authChangeCurrentUser(token, user_id, first_name, last_name, account_name, parent_user_id, impersonation_for_id));

                dispatch(tokenRestoreSuccess());
                return;
            }
        } 

        let tryToRefreshToken = true;

        if (token && user_id) {
            try {
                //token ?
                const response = await axios.get( '/users/'+user_id, { skipRedirectToLoginIfUnauthorized: true, token } );
                const { first_name, last_name, account_name, parent_user_id } = response.data;
                tryToRefreshToken = false;
                
                dispatch(authChangeCurrentUser(token, user_id, first_name, last_name, account_name, parent_user_id));
                dispatch(tokenRestoreSuccess());
                return;
            } catch (e) {
                console.error(e);
                dispatch(authRemoveMelcoAccountData());
            }
        }

        if (tryToRefreshToken) {
            try {
                const response = await axios.get( '/auth/melco/refresh', { withCredentials: true, skipRedirectToLoginIfUnauthorized: true } );
                const { token, user_id, first_name, last_name, account_name, parent_user_id } = response.data;
                dispatch(authChangeCurrentUser(token, user_id, first_name, last_name, account_name, parent_user_id));

                if (token && user_id) {
                    dispatch(authSetMelcoAccountData(token, user_id, first_name, last_name));
                    dispatch(tokenRestoreSuccess());
                    return;
                }
            } catch (e) {
                console.error(e);
            }
        }

        dispatch(tokenRestoreFail());
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/tokenRestore.js